@let options = (filteredOptions$ | async) ?? [];
@let error = error$ | async;
@let loading = (loading$ | async) ?? false;

<mat-form-field
  class="w-full"
  subscriptSizing="dynamic">
  <mat-select
    [formControl]="control"
    [placeholder]="placeholder"
    [compareWith]="compareWith"
    [ngClass]="{ 'hide-select': loading }"
    multiple>
    <mat-select-trigger>
      @if (control.value && control.value.length > 0) {
        {{ selectedLabel }}
      }
    </mat-select-trigger>

    @if (searchable) {
      <mat-form-field
        class="sticky top-0 left-0 form-sm w-full bg-white z-10 mb-2"
        (click)="$event.stopPropagation()"
        subscriptSizing="dynamic">
        <input
          matInput
          type="text"
          [formControl]="searchControl"
          [placeholder]="'libs.async-select.search' | translate" />
      </mat-form-field>
    }

    <!--
        When search filters options, selected items that don't match the query are removed from the DOM.
        mat-select then drops them from its selection model and the trigger goes blank.
        Render a hidden mat-option for each selected item not currently visible so the selection is preserved.
    -->
    @for (selected of control.value ?? []; track $index) {
      @if (!isInOptions(selected, options)) {
        <mat-option
          [value]="selected"
          class="hidden"></mat-option>
      }
    }

    @for (option of options; track $index) {
      <mat-option [value]="option">
        @if (optionTemplateRef) {
          <ng-container
            [ngTemplateOutlet]="optionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: option }">
          </ng-container>
        } @else {
          <span class="line-clamp-2"> {{ displayWith ? displayWith(option) : option }} </span>
        }
      </mat-option>
    }

    @if (options.length === 0 && !loading && !error) {
      <mat-option disabled>
        {{ "libs.async-select.no-results" | translate }}
      </mat-option>
    }
  </mat-select>

  @if (loading) {
    <div
      matSuffix
      class="flex w-full h-full justify-end items-center pr-3">
      <mat-spinner
        class="block"
        diameter="21"
        mode="indeterminate" />
    </div>
  }

  @if (error && error.length > 0 && !loading) {
    <mat-hint class="text-ruber opacity-100">
      {{ error | translate }}
      <span
        (click)="retry.emit()"
        class="underline hover:font-bold hover:cursor-pointer"
        translate>
        libs.async-select.retry
      </span>
    </mat-hint>
  }
</mat-form-field>
